import {Box, Button} from "@mui/material";
import InquiriesTable from "../../features/deal/dealInterest/InquiriesTable";
import OffersTable from "../../features/deal/dealInterest/OffersTable";
import {useState} from "react";

interface Props {
  property: any;
}

const InterestsDrawerMarketplace = ({property}: Props) => {
  const [activeInquiry, setActiveInquiry] = useState(false);

  return (
    <Box
      sx={{
        flex: 1,
        backgroundColor: "#F2F6FA",
        padding: "20px",
      }}
    >
      <Box sx={{backgroundColor: "#EAF0F5"}}>
        <Button
          onClick={() => setActiveInquiry(false)}
          sx={{
            paddingLeft: "15px",
            paddingTop: "15px",
            paddingBottom: "15px",
            color: activeInquiry ? "#616161" : "#0D2561",
            borderBottom: activeInquiry
              ? "none"
              : "2px solid rgba(13, 37, 97, 1)",
            borderRadius: 0,
          }}
        >
          OFFERS
        </Button>
        <Button
          onClick={() => setActiveInquiry(true)}
          sx={{
            paddingLeft: "15px",
            paddingTop: "15px",
            paddingBottom: "15px",
            color: activeInquiry ? "#0D2561" : "#616161",
            borderBottom: activeInquiry
              ? "2px solid rgba(13, 37, 97, 1)"
              : "none",
            borderRadius: 0,
          }}
        >
          INQUIRIES
        </Button>
      </Box>

      {activeInquiry ? (
        <InquiriesTable dealId={property.id} isServiceCard={false} />
      ) : (
        <OffersTable dealId={property.id} />
      )}
    </Box>
  );
};

export default InterestsDrawerMarketplace;
